import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../../redux/exam/examSlice";

const LanguageToggle = () => {
  const dispatch = useDispatch();
  const currentLang = useSelector((state) => state.examSlice.currentLang);

  const handleToggle = () => {
    const newLang = currentLang === "en" ? "hi" : "en";
    dispatch(setLanguage(newLang));
  };

  return (
    <button
      onClick={handleToggle}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        border: "none",
        background: "transparent",
        cursor: "pointer",
        fontSize: "32px",
      }}
    >
      <span
        style={{
          fontSize: "14.4px",
          fontWeight: "bold",
          color: currentLang === "en" ? "orange" : "#555",
        }}
      >
        A
      </span>

      <span style={{ fontSize: "12px", color: "#555" }}>⇄</span>

      <span
        style={{
          fontSize: "14.4px",
          fontWeight: "bold",
          color: currentLang === "hi" ? "orange" : "#555",
        }}
      >
        अ
      </span>
    </button>
  );
};

export default LanguageToggle;
